import { createContext, useState } from 'react'

export interface ContextType {
  filterLabel: string
  setFilterLabel: any
}

export const DashboardContext = createContext<Partial<ContextType>>({})

const Context = ({ children }: any) => {
  const [filterLabel, setFilterLabel] = useState<string>('All')

  return (
    <DashboardContext.Provider
      value={{
        filterLabel,
        setFilterLabel
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export default Context
